// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1V6hm","startPage":"style_startPage_TiCRM"};